import React, { useEffect } from 'react';
import { AuthenticatedImage } from './AuthenticatedImage';

interface FullscreenViewerProps {
  imageUrl: string;
  accessToken: string;
  onClose: () => void;
}

const FullscreenViewer: React.FC<FullscreenViewerProps> = ({ imageUrl, accessToken, onClose }) => {
  // Handle ESC key to close
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div 
      className="fixed inset-0 z-50 bg-black bg-opacity-95 flex items-center justify-center p-4"
      onClick={onClose}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
        aria-label="Close fullscreen"
      >
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      {/* Image */}
      <div onClick={(e) => e.stopPropagation()}>
        <AuthenticatedImage
          src={imageUrl}
          alt="Fullscreen view"
          accessToken={accessToken}
          className="max-w-full max-h-full object-contain"
        />
      </div>

      {/* Instructions */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white text-sm bg-black bg-opacity-50 px-4 py-2 rounded-lg">
        Press <kbd className="px-2 py-1 bg-gray-700 rounded">ESC</kbd> or click outside to close
      </div>
    </div>
  );
};

export default FullscreenViewer;

